<plan-clase-form
    [asignaturaId]="asignaturaId"
    [tipoEvaluacion]="tipoEvaluacion"
    [planClase]="planClase"
    (save)="save($event)"
    [enableModelos]="enableModelos"
    [disableSave]="disableSave"
></plan-clase-form>
